import React from 'react';
import Icon from '@pushpay/icon';
import { createUseStyles, clsx } from '@pushpay/styles';
const useStyles = createUseStyles({
  root: {},
  animate: {
    animation: '$spin 1s linear infinite'
  },
  '@keyframes spin': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
});

const LoadingOvalIcon = props => {
  const {
    animate = true,
    className: classNameProp,
    classes: classesProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root, animate && classes.animate);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 38 38",
    className: className
  }, rest), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  })));
};

export default LoadingOvalIcon;